import { Box, Flex, Heading, Stack, Text } from "@chakra-ui/layout"
import Icon from "@chakra-ui/icon"
import React from "react"
import PensilLeftIcon from "../../assets/pencil-left.svg"
import { Image } from "@chakra-ui/image"
import { Button } from "@chakra-ui/button"
import BigPlayIcon from "../../assets/big-play-icon.svg"
import { motion } from "framer-motion"
import ReactPlayer from "react-player"
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay } from "@chakra-ui/modal"
import { useDisclosure } from "@chakra-ui/hooks"

const MotionBtn = motion(Button)
const videoUrls = [
    { video: "David Simunić", url: "UuM3HItOKoY" },
    { video: "Dina Lalovic", url: "TP7R3-AkDQk" },
    { video: "Ana Ivanovic", url: "fHHqxeZ2pqI" },
]

const Ambassadors = () => {
    const { isOpen: isOpen1, onOpen: onOpen1, onClose: onClose1 } = useDisclosure()
    const { isOpen: isOpen2, onOpen: onOpen2, onClose: onClose2 } = useDisclosure()
    const { isOpen: isOpen3, onOpen: onOpen3, onClose: onClose3 } = useDisclosure()

    const YTplayModal = (url, isOpen, onClose) => {
        return (
            <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
                <ModalOverlay bg="rgba(23, 18, 10, 0.85)" />
                <ModalContent>
                    <ModalCloseButton top="-10" bg="#fff" _hover={{ bg: "#fff" }} />
                    <ModalBody pt="56.25%">
                        {/* Video... */}
                        <ReactPlayer
                            url={` https://www.youtube.com/watch?v=${url}`}
                            style={{
                                position: "absolute",
                                top: "0",
                                left: "0",
                            }}
                            width="100%"
                            height="100%"
                            controls
                            playing
                            config={{
                                youtube: {
                                    preload: true,
                                },
                            }}
                        />
                    </ModalBody>
                </ModalContent>
            </Modal>
        )
    }

    return (
        <Stack
            w="100%"
            mt={["20px", "20px", "46px"]}
            // minH="100vh"
            spacing={["44px", "44px", "64px", "64px", "167px"]}
            color="#fff"
            overflowX="hidden"
            pb="10px"
        >
            <Flex
                w="100%"
                bg="_red"
                h={["fit-content", "fit-content", "157px"]}
                justify="space-between"
                align="center"
                display={["none", "flex"]}
                mb="20px"
            >
                <Flex
                    justify="flex-start"
                    transform={[null, "translate(0px, 70px)", "translate(0px, 78px)"]}
                >
                    <Icon as={PensilLeftIcon} w="100%" h="138px" />
                </Flex>
                <Heading
                    fontSize={["28px", "32px", "38px", "54px", "72px"]}
                    fontWeight="900"
                    color="#fff"
                    whiteSpace={["normal", "normal", "nowrap"]}
                    textTransform="uppercase"
                    pr={["0px", "0px", "40px", "40px", "100px"]}
                    minW={["220px", "290px", "unset"]}
                    textAlign="center"
                >
                    Лица наше кампање
                </Heading>
            </Flex>
            <Flex
                h={["218px", "350px", "400px", "600px", "800px"]}
                w={["108%", "105%", "90%"]}
                bg="_olive"
                borderLeftRadius="full"
                alignSelf="flex-end"
                align="center"
                pos="relative"
            >
                <Flex w="50%" h="100%">
                    <Flex w="100%" h="100%" justify="center" align="center" zIndex="10">
                        <MotionBtn
                            onClick={onOpen1}
                            w={["50px", "70px", "120px", "198px"]}
                            h={["60px", "80px", "135px", "217px"]}
                            variant="playBtn"
                            p="0"
                            whileHover={{ scale: 1.0 }}
                            whileTap={{ scale: 0.98 }}
                            display="block"
                            _focus={{ boxShadow: "none" }}
                            _hover={{ bg: "#BBBDB8" }}
                            css={{
                                clipPath: "polygon(100% 50%, 0 0, 0 100%)",
                            }}
                        >
                            <Icon as={BigPlayIcon} w="198px" h="217px" />
                        </MotionBtn>
                        {YTplayModal(videoUrls[0].url, isOpen1, onClose1)}
                    </Flex>

                    <Image
                        src="portrait2.png"
                        pos="absolute"
                        bottom="0"
                        left={["0"]}
                        transform={[
                            "translate(16px,0)",
                            "translate(30px,0)",
                            "translate(56px,0)",
                            "translate(74px,0)",
                            "translate(96px,0px)",
                        ]}
                        h={["226px", "350px", "420px", "650px", "unset"]}
                    />
                </Flex>
                <Flex w="50%" justify="center" align="center">
                    <Stack textAlign="center" w="385px" spacing={8}>
                        {/* <Text
                            fontSize={["20px", "32px", "54px"]}
                            fontWeight="700"
                            lineHeight={["30px", "40px", "60px"]}
                        >
                            "Цитат из видео клипа"
                        </Text> */}
                        <Box>
                            <Text fontSize={["18px", "18px", "28px"]} fontWeight="700">
                                Давид Шимунић
                            </Text>
                            <Text fontSize={["18px", "18px", "28px"]} fontWeight="200">
                                je шеф кухиње
                            </Text>
                        </Box>
                    </Stack>
                </Flex>
            </Flex>
            <Flex
                h={["218px", "350px", "400px", "600px", "800px"]}
                w={["108%", "103%", "90%"]}
                bg="_blue"
                borderRightRadius="full"
                alignSelf="flex-start"
                align="center"
                justify="space-between"
                pos="relative"
            >
                <Flex w="50%" justify="center" align="center">
                    <Stack textAlign="center" w="385px" spacing={8}>
                        {/* <Text fontSize="54px" fontWeight="700" lineHeight="60px">
                            "Цитат из видео клипа"
                        </Text> */}
                        <Box>
                            <Text fontSize={["18px", "18px", "28px"]} fontWeight="700">
                                Дина Лаловић
                            </Text>
                            <Text fontSize={["18px", "18px", "28px"]} fontWeight="200">
                                je пилот
                            </Text>
                        </Box>
                    </Stack>
                </Flex>
                <Flex w="50%" h="100%">
                    <Flex w="100%" h="100%" justify="center" align="center" zIndex="10">
                        <MotionBtn
                            onClick={onOpen2}
                            w={["50px", "70px", "120px", "198px"]}
                            h={["60px", "80px", "135px", "217px"]}
                            variant="playBtn"
                            p="0"
                            whileHover={{ scale: 1.01 }}
                            whileTap={{ scale: 1 }}
                            _focus={{ boxShadow: "none" }}
                            _hover={{ bg: "#BBBDB8", border: "none" }}
                            _active={{ bg: "#dae0d5" }}
                            css={{
                                clipPath: "polygon(100% 50%, 0 0, 0 100%)",
                            }}
                        >
                            <Icon as={BigPlayIcon} w="198px" h="217px" />
                        </MotionBtn>
                        {YTplayModal(videoUrls[1].url, isOpen2, onClose2)}
                    </Flex>
                    <Image
                        src="portrait3.png"
                        pos="absolute"
                        transform={[
                            "unset",
                            "translate(-8px,0)",
                            "translate(-3px,0)",
                            "translate(-3px,0)",
                            "translate(0,0)",
                        ]}
                        bottom="0"
                        right="0"
                        h={["230px", "360px", "420px", "650px", "unset"]}
                    />
                </Flex>
            </Flex>
            <Flex
                h={["218px", "350px", "400px", "600px", "800px"]}
                w={["108%", "103%", "90%"]}
                bg="_red"
                borderLeftRadius="full"
                alignSelf="flex-end"
                align="center"
                justify="space-between"
                pos="relative"
            >
                <Flex w="50%" h="100%">
                    <Flex w="100%" h="100%" justify="center" align="center" zIndex="10">
                        <MotionBtn
                            onClick={onOpen3}
                            w={["50px", "70px", "120px", "198px"]}
                            h={["60px", "80px", "135px", "217px"]}
                            variant="playBtn"
                            p="0"
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            _focus={{ boxShadow: "none" }}
                            _hover={{ bg: "#BBBDB8" }}
                            css={{
                                clipPath: "polygon(100% 50%, 0 0, 0 100%)",
                            }}
                        >
                            <Icon as={BigPlayIcon} w="198px" h="217px" />
                        </MotionBtn>
                    </Flex>
                    <Image
                        src="portrait1.png"
                        pos="absolute"
                        bottom="0"
                        left={["0"]}
                        transform={[
                            "translate(25px,0)",
                            "translate(42px,0)",
                            "translate(42px,0)",
                            "translate(70px,0)",
                            "translate(80px,0px)",
                        ]}
                        h={["230px", "360px", "420px", "650px", "unset"]}
                    />
                    {YTplayModal(videoUrls[2].url, isOpen3, onClose3)}
                </Flex>
                <Flex w="50%" justify="center" align="center">
                    <Stack textAlign="center" w="385px" spacing={8}>
                        {/* <Text fontSize="54px" fontWeight="700" lineHeight="60px">
                            "Цитат из видео клипа"
                        </Text> */}
                        <Box>
                            <Text fontSize={["18px", "18px", "28px"]} fontWeight="700">
                                Ана Ивановић
                            </Text>
                            <Text fontSize={["18px", "18px", "28px"]} fontWeight="200">
                                je учитељица
                            </Text>
                        </Box>
                    </Stack>
                </Flex>
            </Flex>
        </Stack>
    )
}

export default Ambassadors
